<script>
import { orderReportMethods, customerMethods } from '../../state/helpers'
export default {
  props: {
    selectstandardtime: {
      type: String,
      default: '',
    },
    fields: {
      type: Array,
      default: null,
    },
    showTimeZones: {
      type: String,
      default: 'Y',
    },
    showAdvanced: {
      type: Boolean,
      default: false,
    },
    processors: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      searchUsers: [],
      customers: [],
      searchKey: 'All',
      prependstart: 'Start Date',
      prependend: 'End Date',
      selectedDate: null,
      startdate: null,
      enddate: null,
      isAdvanceSearch: false,
      requestId: '',
      fileId: '',
      applicant: '',
      customer: '',
      processor: '',
      ssn: '',
      orderedBy: '',
      orderedFor: '',
      product: '',
      status: '',
      rush: '',
      costToBorrower: false,
      costToBusiness: false,
      search: '',
      maxdate: '',
      optionsusers: [
        { value: 'All', text: 'All' },
        { value: 'RequestId', text: 'Request#' },
        { value: 'Request', text: 'Request Type' },
        { value: 'File', text: 'File#' },
        { value: 'ApplicantName', text: 'Applicant Name' },
        { value: 'ProcessorName', text: 'Processor' },
        { value: 'OrderedBy', text: 'Ordered by' },
        { value: 'Rush', text: 'Rush' },
        { value: 'CustomerName', text: 'Customer' },
        { value: 'Status', text: 'Request Status' },
      ],
      rushOptions: [
        { value: true, text: 'Yes' },
        { value: false, text: 'No' },
      ],
    }
  },
  computed: {
    recordsStatusList() {
      const types = this.$_supplementStatusList.map((i) => {
        return {
          text: i.text,
          value: i.text,
        }
      })

      if (types.length === 0) {
        const d = ['New', 'InProgress', 'Completed', 'Withdrawn', 'Cancelled']
        return d.map((item) => {
          return {
            text: item,
            value: item,
          }
        })
      }

      return types
    },
    requestTypesList() {
      const types = this.$_requestTypesList.map((i) => {
        return {
          text: i.text,
          value: i.text,
        }
      })

      if (types.length === 0) {
        const d = ['Rescore', 'Supplement', 'VOD', 'VOE', 'VOESelfEmployed']
        return d.map((item) => {
          return {
            text: item,
            value: item,
          }
        })
      }

      return types
    },
  },
  mounted() {
    document.body.addEventListener('keyup', (e) => {
      if (e.keyCode === 27) {
        this.isDefault = true
        this.isOpen = false
      }
    })

    // To bind the User Options dropdown.
    this.prepareUserOptionsList()
    this.getMaxDateLimit()
    this.setStartDate()
    this.setEndDate()
  },
  methods: {
    ...orderReportMethods,
    ...customerMethods,
    getKey() {
      return Math.random()
        .toString(36)
        .replace(/[^a-z]+/g, '')
        .substr(0, 7)
    },
    getCustomerData() {
      this.searchUsers = []
      this.getCustomerUsers()
    },
    getCustomerUsers() {
      var customerId = this.customer ? this.customer.value : ''
      if (!customerId) return

      this.showSpinner = true
      this.searchUsers = []
      this.orderedBy = ''
      this.orderedFor = ''

      return this.fetchCustomerUser({
        customerId,
      })
        .then((response) => {
          if (response.data && Array.isArray(response.data)) {
            this.searchUsers = response.data.map((item) => {
              return {
                text: item.userFullName,
                value: item.userID,
              }
            })
          } else {
            this.customerUsers = []
          }
          this.showSpinner = false
        })
        .catch((error) => {
          this.showSpinner = false
          this.authError = error
        })
    },
    getProcessors() {
      this.showSpinner = true
      this.processor = null
      return this.fetchCreditManagerOrProcessors({ customerId: 1, roleId: 3 })
        .then((response) => {
          this.processors = response.customers.map((x) => {
            return {
              text: x.userFullName,
              value: x.userID,
            }
          })
          this.showSpinner = false
        })
        .catch((error) => {
          this.showSpinner = false
          this.authError = error
        })
    },
    getCustomers() {
      this.showSpinner = true
      return this.fetchCustomersByUserId()
        .then((response) => {
          this.customers = response.customers.map((x) => {
            return {
              text: x.name,
              value: x.customerId,
            }
          })
          this.showSpinner = false
        })
        .catch((error) => {
          this.showSpinner = false
          this.authError = error
        })
    },
    resetAdvancedSearch() {
      this.requestId = ''
      this.fileId = ''
      this.applicant = ''
      this.processor = ''
      this.customer = ''
      this.ssn = ''
      this.orderedBy = ''
      this.orderedFor = ''
      this.product = ''
      this.status = ''
      this.rush = ''
      this.costToBusiness = false
      this.costToBorrower = false
      this.searchProducts = []
      this.searchUsers = []
      this.setStartDate()
      this.setEndDate()
    },
    showAdvancedSearch() {
      this.isAdvanceSearch = !this.isAdvanceSearch
      if (!this.isAdvanceSearch) {
        this.resetAdvancedSearch()
      }

      if (this.isAdvanceSearch) {
        if (!this.customers || this.customers.length === 0) {
          this.getCustomers()
        }
        if (!this.processors || this.processors.length === 0) {
          this.getProcessors()
        }
        if (!this.searchUsers || this.searchUsers.length === 0) {
          this.getCustomerUsers()
        }
      }
      this.$emit('advanceSearchChanged', this.isAdvanceSearch)
    },
    onSearchSubmit(selectedValue) {
      this.$validator.validateAll().then((result) => {
        if (result) this.$emit('searchSubmit', selectedValue)
      })
    },
    setStartDate() {
      let today = new Date()
      let month =
        today.getMonth() + 1 <= 9
          ? '0' + (today.getMonth() + 1)
          : today.getMonth() + 1

      this.startdate = `${month}/${today.getDate()}/${today.getFullYear()}`
    },
    setEndDate() {
      let today = new Date()
      let month =
        today.getMonth() + 1 <= 9
          ? '0' + (today.getMonth() + 1)
          : today.getMonth() + 1

      this.enddate = `${month}/${today.getDate()}/${today.getFullYear()}`
    },

    getMaxDateLimit() {
      let today = new Date()
      let month =
        today.getMonth() + 1 <= 9
          ? '0' + (today.getMonth() + 1)
          : today.getMonth() + 1

      this.maxdate = `${month}/${today.getDate()}/${today.getFullYear()}`
    },
    // Preparing the User Options list based on the 'fields' property which is used for Grid header.
    prepareUserOptionsList() {
      if (this.fields !== undefined && this.fields != null) {
        this.optionsusers = []

        this.fields.forEach((item, index) => {
          if (item.sortable)
            this.optionsusers.push({ value: item.key, text: item.label })
        })

        // Adding 'All' option to display as first option.
        this.optionsusers.unshift({ value: 'All', text: 'All' })
      }
    },
  },
}
</script>

<template>
  <b-form
    novalidate
    @submit.prevent="
      onSearchSubmit({
        startdate,
        enddate,
        selectstandardtime,
        key: searchKey || 'All',
        search,
        requestId: requestId || null,
        fileId: fileId || null,
        applicant: applicant || null,
        orderedBy: orderedBy ? orderedBy.value : null,
        orderedFor: orderedFor ? orderedFor.value : null,
        product: product,
        status: status,
        customer: customer ? customer.value : null,
        processor: processor ? processor.text : null,
        rush: rush || null,
        isAdvanceSearch,
      })
    "
  >
    <b-row v-show="!isAdvanceSearch" class=" mx-0">
      <b-col md="auto" class="p-0 startdate">
        <BaseDate
          v-model="startdate"
          v-validate="'required'"
          type="date"
          :field-id="getKey()"
          name="startdate"
          :max="maxdate"
          :prepend="prependstart"
          :class="{
            input: true,
            'is-danger': errors.has('startdate'),
          }"
        ></BaseDate>
        <div v-show="errors.has('startdate')" class="error"
          >Invalid Start Date</div
        >
      </b-col>
      <b-col md="auto" class="px-2 enddate">
        <BaseDate
          v-model="enddate"
          v-validate="'required'"
          type="date"
          :field-id="getKey()"
          name="enddate"
          :min="startdate"
          :max="maxdate"
          :prepend="prependend"
          :class="{
            input: true,
            'is-danger': errors.has('enddate'),
          }"
        ></BaseDate>
        <div v-show="errors.has('enddate')" class="error">Invalid End Date</div>
      </b-col>
      <b-col md="5" class="px-0">
        <b-input-group>
          <b-form-select
            slot="prepend"
            v-model="searchKey"
            :options="optionsusers"
            :class="$style.searchAllignment"
            class="rounded-0"
          ></b-form-select>
          <b-form-input
            v-model="search"
            class="rounded-0"
            maxlength="50"
            placeholder="Type to Search"
          ></b-form-input>
          <BaseEButton slot="append" type="submit" pre-icon="search"
            >Search</BaseEButton
          >
        </b-input-group>
      </b-col>
      <div class="d-inline-block px-1">
        <BaseEButton
          v-if="showAdvanced"
          slot="append"
          variant="icon"
          @click="showAdvancedSearch"
        >
          Advanced Search
        </BaseEButton>
      </div>
    </b-row>

    <div v-show="isAdvanceSearch" class="mx-3">
      <b-row>
        <b-col md="auto" class="p-0 startdate">
          <BaseELabel
            class="advancedSearchStyle"
            mark-required
            label="Request Date From"
          />
          <BaseDate
            v-model="startdate"
            v-validate="'required'"
            type="date"
            :field-id="getKey()"
            name="startdate"
            :max="maxdate"
            :prepend="prependstart"
            :class="{
              input: true,
              'is-danger': errors.has('startdate'),
            }"
          ></BaseDate>
          <div v-show="errors.has('startdate')" class="error"
            >Invalid Start Date</div
          >
        </b-col>
        <b-col md="auto" class="px-2 enddate">
          <BaseELabel
            class="advancedSearchStyle"
            mark-required
            label="Request Date To"
          />
          <BaseDate
            v-model="enddate"
            v-validate="'required'"
            type="date"
            :field-id="getKey()"
            name="enddate"
            :min="startdate"
            :max="maxdate"
            :prepend="prependend"
            :class="{
              input: true,
              'is-danger': errors.has('enddate'),
            }"
          ></BaseDate>
          <div v-show="errors.has('enddate')" class="error"
            >Invalid End Date</div
          >
        </b-col>
        <b-col md="1" class="px-1">
          <BaseELabel class="advancedSearchStyle" label="Request #" />
          <b-form-input
            v-model="requestId"
            name="requestId"
            maxlength="20"
            :class="{
              input: true,
            }"
            placeholder="Request #"
          ></b-form-input>
        </b-col>
        <b-col md="1" class="px-1">
          <BaseELabel class="advancedSearchStyle" label="File #" />
          <BaseEInputText
            :id="getKey()"
            v-model="fileId"
            name="fileId"
            maxlength="20"
            :class="{
              input: true,
              'is-danger': errors.has('fileId'),
            }"
            placeholder="File #"
          ></BaseEInputText>
        </b-col>
        <b-col md="1" class="px-1">
          <BaseELabel class="advancedSearchStyle" label="Applicant" />
          <BaseEInputText
            :id="getKey()"
            v-model="applicant"
            name="applicant"
            maxlength="50"
            :class="{
              input: true,
              'is-danger': errors.has('applicant'),
            }"
            placeholder="Applicant"
          ></BaseEInputText>
        </b-col>
        <b-col md="2" class="d-inline-block px-1">
          <BaseELabel class="advancedSearchStyle" label="Processor" />
          <BaseMultiSelect
            v-model="processor"
            type="text"
            :multiple="false"
            name="processor"
            placeholder="Select"
            data-vv-as="Processor[s]"
            label="text"
            track-by="value"
            :options="processors"
            :close-on-select="true"
            :clear-on-select="false"
            :class="$style.dropOptionstyle"
          />
        </b-col>
        <b-col md="1" class="px-1">
          <BaseELabel class="advancedSearchStyle" label="Rush" />
          <BaseDropdown
            v-model="rush"
            :field-id="rush"
            :options="rushOptions"
            class="mb-1"
            name="rush"
            placeholder="Select"
          ></BaseDropdown>
        </b-col>
      </b-row>
      <b-row class="pb-3">
        <b-col md="3" class="d-inline-block px-0">
          <b-col md="6" class="d-inline-block px-1">
            <BaseELabel class="advancedSearchStyle" label="Customer" />
            <BaseMultiSelect
              v-model="customer"
              type="text"
              :options="customers"
              :multiple="false"
              name="customer"
              placeholder="Select"
              data-vv-as="Customer[s]"
              label="text"
              track-by="value"
              :close-on-select="true"
              :clear-on-select="false"
              :class="$style.dropOptionstyle"
              @close="getCustomerData"
            />
          </b-col>
          <b-col md="6" class="d-inline-block px-1">
            <BaseELabel class="advancedSearchStyle" label="Ordered By" />
            <BaseMultiSelect
              v-model="orderedBy"
              type="text"
              :options="searchUsers"
              :multiple="false"
              name="orderedBy"
              placeholder="Select"
              data-vv-as="orderedBy"
              label="text"
              track-by="value"
              :close-on-select="true"
              :clear-on-select="false"
              :class="$style.dropOptionstyle"
            />
          </b-col>
        </b-col>
        <b-col md="2" class="d-inline-block px-1">
          <BaseELabel class="advancedSearchStyle" label="Request Type" />
          <BaseDropdown
            v-model="product"
            type="text"
            :options="requestTypesList"
            :multiple="false"
            name="product"
            placeholder="Select"
            label="text"
            class="adjustedDropdown"
          />
        </b-col>
        <b-col md="1" class="d-inline-block px-1">
          <BaseELabel class="advancedSearchStyle" label="Request Status" />
          <BaseDropdown
            v-model="status"
            :field-id="status"
            :options="recordsStatusList"
            class="mb-1 adjustedDropdown"
            name="status"
            placeholder="Select"
          ></BaseDropdown>
        </b-col>
        <b-col md="4" class="ml-2 px-3">
          <b-row class="my-3" style="margin-top:-2px"> </b-row>
          <b-row>
            <b-col md="auto" class="px-1">
              <BaseEButton slot="append" pre-icon="search" type="submit"
                >Search</BaseEButton
              >

              <BaseEButton
                slot="append"
                variant="icon"
                pre-icon="sync"
                @click="resetAdvancedSearch"
                >Reset</BaseEButton
              >

              <BaseEButton
                slot="append"
                variant="icon"
                pre-icon="times-circle"
                @click="showAdvancedSearch"
              >
                Close
              </BaseEButton>
            </b-col>
          </b-row>
        </b-col>

        <!-- <div class="d-inline-block">
          <a
            href="#"
            class="btn btn-link text-white-50 bg-transparent border-0 btn-secondary ml-1"
            @click="$emit('closeButton')"
          >
            <BaseIcon name="times" />
          </a>
        </div> -->
      </b-row>
    </div>
  </b-form>
</template>

<style lang="scss" scoped>
.advancedSearchStyle {
  font-size: 0.7rem;
  color: #b1aeae;
}
.advancedSearchStyle.normalize {
  font-size: 1rem;
  color: #dfdbdb;
}
</style>
<style lang="scss" module>
@import '@design';
.searchReport {
  padding: 5px;
  background-color: #2e4253;
  opacity: 1;
}
.searchAllignment {
  width: 170px;
}
.borderRadiusLeft {
  width: 260px;
  border-top-left-radius: 5px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 5px;
}

.borderRadiusRight {
  border-top-left-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 0;
}
</style>
<style>
.adjustedDropdown select {
  min-height: 42px !important;
}
</style>
